import React from 'react';
import './App.css';
import Home from './componentes/landing-chat-gpt';
import Trained from './componentes/chat-gpt-tained';
import NewChat from './componentes/chat-gpt';
import SingleGpt from './componentes/single-chat-gpt';
import SingleChatEquipo from './componentes/single-chat-equipo-gpt';
import SingleTrained from './componentes/single-chat-trained';
import UserLink from './componentes/cloninger/SurveyCompopnentCloningerLink';
import UserLinkMail from './componentes/encuesta/UserLinkMail2'; 
import EstadoLink from './componentes/encuesta/chat-Estadolink';
import EstadoEquipo from './componentes/encuesta/chat-EstadoEquipo';
import UserLinkOwner from './componentes/chat-link2';
import CrearEquipo from './componentes/chat-equipo';
import Miequipo from './componentes/chat-super';
import DashboardBase from './componentes/dashoboard/UserDash';
import TrabajoPrincipal from './componentes/trabajo/pricipal'; 
import SingleJobPage from './componentes/trabajo/SingleJobPage';
import TCITestForm from './componentes/cloninger/TCITestForm';
import UserPlayerPage from './nawiempresas/UserPlayerPage';
import DashboardEmpresa from './nawiempresas/DashboardEmpresa';
import AdminPanel from './nawiempresas/AdminPanel';
import ConsultasIA from './nawiempresas/ConsultasIA';
import Agentes from './nawiempresas/Agentes';
import Consumo from './nawiempresas/Consumo';
import Soporte from './nawiempresas/Soporte';
import Conflictos from './nawiempresas/Conflictos';
import { Activar, ValidarEmail } from './nawiempresas/ValidacionPublica';
import LoginPage from './nawiempresas/LoginPage';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './nawiempresas/AuthContext';

function App() {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      // El logo redondo de NAWI gira sobre su propio centro mientras se valida la sesión
      <div className="inicio-cargando" role="status" aria-label="Cargando NAWI Office">
        <img className="inicio-cargando-logo" src="/images/logo512.png" alt="" />
      </div>
    );
  }

  // Sesion completa: sin pasos pendientes del primer ingreso (validar el email y cambiar la contraseña provisoria).
  const completa = isAuthenticated && !user?.validarEmail && !user?.mustChangePassword;

  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={
            !completa ? <LoginPage /> :
            <Navigate to="/altaEmpresa" />
          } />
          <Route path="/userlink/:postId" element={<UserLink />} />
          <Route path="/userlinkMail/:postId" element={<UserLinkMail />} />
          {/* Paginas publicas de los codigos de validacion (desde el 25/10/2026) */}
          <Route path="/activar" element={<Activar />} />
          <Route path="/validar-email" element={<ValidarEmail />} />
          
          {completa && (
            <>
              <Route path="/altaEmpresa" element={<DashboardEmpresa />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/consultas-ia" element={<ConsultasIA />} />
              <Route path="/agentes" element={<Agentes />} />
              <Route path="/consumo" element={<Consumo />} />
              <Route path="/soporte" element={<Soporte />} />
              <Route path="/conflictos" element={<Conflictos />} />
              <Route path="/conflictos/:id" element={<Conflictos />} />
              <Route path="/chat/:postId" element={<SingleGpt />} />
              <Route path="/singletrained/:postId" element={<SingleTrained />} />
              <Route path="/chatEquipo/:postId" element={<SingleChatEquipo />} />
              <Route path="/trained" element={<Trained />} />
              <Route path="/userlinkOwner" element={<UserLinkOwner />} />
              <Route path="/estadoLink/:postId" element={<EstadoLink />} />
              <Route path="/estadoEquipo/:postId" element={<EstadoEquipo />} />
              <Route path="/dashboard" element={<DashboardBase />} />
              <Route path="/equipos" element={<CrearEquipo />} />
              <Route path="/miequipo" element={<Miequipo />} />
              <Route path="/createJob" element={<TrabajoPrincipal />} />
              <Route path="/job/:id" element={<SingleJobPage />} />
              <Route path="/tci" element={<TCITestForm />} />
              <Route path="/players/:id" element={<UserPlayerPage />} />
            </>
          )}

          <Route path="*" element={<Navigate to={completa ? "/altaEmpresa" : "/"} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;